import { DatePickerField } from "@/features/projects/cards/components/DatePickerField";

import { type QuestionsProps } from "../types";

export const DatePickerQuestion = ({
  answer,
  onFreeTextAnswered,
}: QuestionsProps) => {
  return (
    <DatePickerField
      value={
        answer?.answerFreeText ? new Date(answer?.answerFreeText) : undefined
      }
      onChange={(localSelected) => {
        const dateString =
          localSelected !== null ? localSelected?.toISOString() : "";
        onFreeTextAnswered?.(dateString);
      }}
      isClearable
    />
  );
};
